module.exports = __webpack_public_path__ + "img/people_wh.2fed3ab0.png";